import Tag from './tag';
import TagGroup from '../tag-group/tag-group';

/* istanbul ignore next */
Tag.install = function(Vue) {
  Vue.component(Tag.name, Tag);
  Vue.component(TagGroup.name, TagGroup);
};

export default Tag;
